import 'primeicons/primeicons.css';
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/bootstrap4-light-blue/theme.css"; //theme
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import "/node_modules/primeflex/primeflex.css";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import './index.scss';
import { store } from "./tools/my-redux-toolkit/store";
import DangNhapComponent from "./Pages/XacThuc/DangNhap";
import DangKyComponent from "./Pages/XacThuc/DangKy";
import QuenMatKhauComponent from "./Pages/XacThuc/QuenMatKhau";
import { SpinnerProvider } from './contexts/SpinnerContext';
import { ToastProvider } from './contexts/ToastContext';
const App = React.lazy(() => import('./App'));
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <SpinnerProvider>
        <ToastProvider>
          <Suspense fallback={<div></div>}>
            <Router>
              <Switch>
                <Route path="/dang-nhap">
                  <DangNhapComponent></DangNhapComponent>
                </Route>
                <Route path="/dang-ky">
                  <DangKyComponent></DangKyComponent>
                </Route>
                <Route path="/quen-mat-khau">
                  <QuenMatKhauComponent></QuenMatKhauComponent>
                </Route>
                <Route path="">
                  <App />
                </Route>
              </Switch>
            </Router>
          </Suspense>
        </ToastProvider>
      </SpinnerProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
